import React from 'react';
import "./FourthSection.css";
import { Col, Container, Row } from 'react-bootstrap';
import img1 from "../../Assets/images/Group 5.png";
import { LiaCheckCircleSolid } from "react-icons/lia";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function FourthSection() {
  const { t } = useTranslation();

  return (
    <div className='fourth-section mt-5 pb-4'>
      <Container>
        <Row className='align-items-center'>
          <Col lg={6} md={12}>
            <h2 className='mb-5'>
              {t("flexible_learning_title")}
              <div className='colored-text'>{t("flexible_learning_subtitle")}</div>
            </h2>

            <div>
              <div className='d-flex align-items-start mb-3'>
                <div><LiaCheckCircleSolid /></div>
                <div>
                  <h6>{t("online_learning")}</h6>
                  <h5>{t("online_learning_desc")}</h5>
                </div>
              </div>

              <div className='d-flex align-items-start mb-3'>
                <div><LiaCheckCircleSolid /></div>
                <div>
                  <h6>{t("self_learning")}</h6>
                  <h5>{t("self_learning_desc")}</h5>
                </div>
              </div>

              <div className='d-flex align-items-start'>
                <div><LiaCheckCircleSolid /></div>
                <div>
                  <h6>{t("blended_learning")}</h6>
                  <h5>{t("blended_learning_desc")}</h5>
                </div>
              </div>
            </div>

            <div className='last-sec my-5 d-flex justify-content-start align-items-center w-100'>
              <Link
                to="/how-we-learn"
                onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              >
                <button>{t("explore_kalemon")}</button>
              </Link>
            </div>
          </Col>

          <Col lg={6} md={12}>
            <div className='img-sec'>
              <img src={img1} alt='' width={"100%"} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FourthSection;
